import { EigLogger as BaseEigLogger } from '@eigtech/ui-shared-logging'
import { LogLevel, Logger } from 'amazon-chime-sdk-js'

export class EigMeetingsLogger implements Logger {
  logger: BaseEigLogger

  constructor(logger: BaseEigLogger) {
    this.logger = logger
  }

  info(message: string): void {
    this.logger.info(message)
  }

  warn(message: string): void {
    this.logger.warn(message)
  }

  error(message: string): void {
    this.logger.error(message)
  }

  debug(message: string): void {
    this.logger.debug(message)
  }

  setLogLevel(level: LogLevel): void {
    const map = {
      [LogLevel.DEBUG]: this.logger.levels.DEBUG,
      [LogLevel.ERROR]: this.logger.levels.ERROR,
      [LogLevel.INFO]: this.logger.levels.INFO,
      [LogLevel.OFF]: this.logger.levels.SILENT,
      [LogLevel.WARN]: this.logger.levels.WARN,
    } as const

    this.logger.setLevel(map[level])
  }

  getLogLevel(): LogLevel {
    const level = this.logger.getLevel()

    const map = {
      [this.logger.levels.DEBUG]: LogLevel.DEBUG,
      [this.logger.levels.ERROR]: LogLevel.ERROR,
      [this.logger.levels.INFO]: LogLevel.INFO,
      [this.logger.levels.SILENT]: LogLevel.OFF,
      [this.logger.levels.WARN]: LogLevel.WARN,
      [this.logger.levels.TRACE]: LogLevel.DEBUG,
    }

    return map[level]
  }
}
